
export const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Kunne ikke lese filen"));
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") return reject(new Error("Ugyldig filinnhold"));
      const commaIndex = result.indexOf(",");
      if (commaIndex < 0) return reject(new Error("Ugyldig base64 format"));
      resolve(result.slice(commaIndex + 1));
    };
    reader.readAsDataURL(file);
  });

export const downloadBase64File = (filename: string, base64: string, contentType: string) => {
  const a = document.createElement("a");
  a.href = `data:${contentType};base64,${base64}`;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};